import React, { Fragment, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import Modal from '../../../../common/Modal';
import Button from "../../../../Button";
import styles from '../../StudentImport/StudentImport.module.sass'
import HeaderMatcher from './HeaderMatcher'

const StudentImport = ({ awardInfoId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [headers, setHeaders] = useState([])
  const [formData, setFormData] = useState()
  const form = useRef(null)

  const handleClick = (e) => {
    e.preventDefault();
    openModal();
  }

  const openModal = () => setIsOpen(true);
  const closeModal = () => {
    setHeaders([])
    setIsOpen(false)
    setIsSubmitting(false)
    setFormData()
  };
  const { register, handleSubmit } = useForm();

  const onSubmit = (data) => {
    setIsSubmitting(true)
    if (!data.csv) {
      toast('Please select a file before continuing', { type: 'error' })
      setIsSubmitting(false)
      return;
    }

    const formData = new FormData(form.current)

    fetch(`/award_infos/${awardInfoId}/get_headers`,
      { method: 'POST', body: formData })
      .then(res => res.json())
      .then(json => {
        const headers = json.data;
        if (headers.length === 0) {
          toast('There were no headers found in your file, or it might be malformed. Please try uploading another file.',
            { type: 'error' })
          setIsSubmitting(false)
          return;
        }
        setHeaders(headers)
        setFormData(formData)
      })
      .catch(() => {
        toast('There was an error processing the file. Please try again or use a different file.',
          { type: 'error' })
        setIsSubmitting(false)
      })
  }

  const renderForm = () => {
    if (headers.length > 0) {
      return (
        <HeaderMatcher
          formData={formData}
          headers={headers}
          closeModal={closeModal}
          awardInfoId={awardInfoId}
        />
      )
    }

    return (
      <form ref={form} onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        <label className={styles.label}>
            <span>
              Upload Excel or CSV File
            </span>

          <input
            {...register("csv", { required: true, message: "Please select a file to upload" })}
            className={styles.input}
            accept=".csv,.xlsx,.xls"
            type="file" />
        </label>

        <div className={styles.formActions}>
          <Button
            fullWidth
            variant='primary'
            disabled={isSubmitting}
          >
            Continue
          </Button>
        </div>
      </form>
    )
  }

  return (
    <Fragment>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Import File"
        headerText="Import File"
      >
        {renderForm()}
      </Modal>

      <Button onClick={handleClick}>
        Upload Excel or CSV
      </Button>
    </Fragment>
  )
}

export default StudentImport;
